// extracted by mini-css-extract-plugin
module.exports = {"container":"TosPreview-module__container___3WUvG"};